import { Typography, Box } from "@mui/material";

export default function HomePage() {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4">Welcome to Online Exam System</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Please login to continue.
      </Typography>
    </Box>
  );
}
